import firebase from 'firebase';

const firebaseConfig = {
	apiKey: 'AIzaSyCxX8ai4XLFw-vZ5ZvVgXAGeP7Fx-Huhtw',
	authDomain: 'plus-uk-meds-40e82.firebaseapp.com',
	projectId: 'plus-uk-meds-40e82',
	storageBucket: 'plus-uk-meds-40e82.appspot.com',
	messagingSenderId: '370909074715',
	appId: '1:370909074715:web:e59c65985d1d8c82c1efbe',
};

firebase.initializeApp(firebaseConfig);

export default firebase;
